import { SimNaoEnum } from 'components/form'

import { ConsultaSeguimentoAplicacaoItemModel } from '../../model-consultaSeguimento'

export enum ConsultaSeguimentoPergunta07OlharParaEnum {
  AVIAO = 'AVIAO',
  CAMINHAO = 'CAMINHAO',
  BICHO = 'BICHO',
  ANIMAL = 'ANIMAL',
}

export enum ConsultaSeguimentoPergunta07ApontaPorEnum {
  AJUDA = 'AJUDA',
  INTERESSE = 'INTERESSE',
}

export interface ConsultaSeguimentoPergunta07Model extends ConsultaSeguimentoAplicacaoItemModel {
  PERGUNTA_07_HEADER?: SimNaoEnum
  PERGUNTA_07_OLHAR_PARA?: Record<ConsultaSeguimentoPergunta07OlharParaEnum, SimNaoEnum>
  PERGUNTA_07_APONTA_COM_DEDO?: SimNaoEnum
  PERGUNTA_07_APONTA_POR?: ConsultaSeguimentoPergunta07ApontaPorEnum
}
